// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-contact-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.bg-contact-container .mailto {
  font-size: 16px;
  font-family: "Barlow";
  font-weight: 600;
  color: #FB263B;
}

.bg-contact {
  padding: 30px;
  background-color: #F5F5F7;
}

.mentions ol li {
  font-size: 34px;
  font-family: "Barlow";
  font-weight: 500;
  color: rgb(18, 16, 16);
}`, "",{"version":3,"sources":["webpack://./src/views/footer/contact.scss","webpack://./src/assets/styles/colors.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AADJ;AAEI;EACI,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,cCXQ;ADWhB;;AAIA;EACI,aAAA;EACA,yBCXM;ADUV;;AAII;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;AADJ","sourcesContent":["@import '../../assets/styles/colors.scss';\n\n.bg-contact-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    .mailto{\n        font-size: 16px;\n        font-family: \"Barlow\";\n        font-weight: 600;\n        color:$primary-color;\n\n    }\n  }\n.bg-contact{\n    padding: 30px;\n    background-color:$light-bg ;\n}\n.mentions{\n    ol li {\n    font-size: 34px;\n    font-family: \"Barlow\";\n    font-weight: 500;\n    color: rgba(18, 16, 16, 1);\n   \n    }\n}\n","$primary-color: #FB263B;\n$primary-color-hover: #ED4E5C;\n$primary-color-press: #F499A1;\n$interaction-dark-bg:#fff;\n$hover-dark-bg:#D5D4D5;\n$press-dark-bg:#969596;\n$light-bg:#F5F5F7;\n$dark-bg:#2D2A2C;\n$text-color:#121010;\n$subText-color:#7D7779;\n$success:#7BBE6A;\n$error:#FF8A00;\n$input-bg:#FAFAFA;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
